import React from 'react';

export default function CommentIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path d='M24 8c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2h-9.001l-3.292 3.293c-.156.156-.359.255-.576.284l-.131.009c-.513 0-.936-.386-.993-.884L10 24.586V22H8c-1.105 0-2-.895-2-2V10c0-1.105.895-2 2-2h16zM14 18h-4c-.552 0-1 .448-1 1 0 .513.386.936.883.993L10 20h4c.552 0 1-.448 1-1 0-.513-.386-.936-.883-.993L14 18zm8-4H10c-.552 0-1 .448-1 1 0 .513.386.936.883.993L10 16h12c.552 0 1-.448 1-1 0-.513-.386-.936-.883-.993L22 14zm-4-4h-8c-.552 0-1 .448-1 1 0 .513.386.936.883.993L10 12h8c.552 0 1-.448 1-1 0-.513-.386-.936-.883-.993L18 10z' />
      </g>
    </svg>
  );
}
